import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import MainView from '../components/MainView/MainView'

import {
  setHeroBanner,
  setHeroBanners,
  setFeatured,
  setFeatureStatus,
  setOffers,
  setPromos,
  setEvents,
  setMovies,
  setMerchants,
  setMalls,
  setCMSMalls,
  setMarketingContentModalData,
  setMarketingContentModalStatus,
  setMerchantsListModalData,
  setStoreModalData,
  setCurrentMallInModal,
  setOurMallModalStatus,
  setCardListModalData,
  setCardListModalStatus,
  setPasyalArticles,
} from '../../../modules/dashboard/actions/creators'

import { setDisplayAppModal } from '../../../modules/explore/actions/creators'

import {
  setPrimaryInfo,
  displayProfileModal,
  setProfileModalPage,
  setTransportationMall,
} from '../../../modules/profile/actions/creators'

import {
  setAccessToken,
  setFirebaseMessagingToken,
} from '../../../modules/auth/actions/creators'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

import {
  setLoyaltyPoints,
  setTransactionsEarned,
  setTransactionsRedeemed,
} from '../../../modules/loyalty/actions/creators'

import { setError, removeError } from '../../../modules/errors/actions/creators'

import { withFirebase } from '../../../components/accessibility/Firebase/Firebase'

import {
  doSubscribeToFirebaseMessaging,
  doSubscribeToFirebaseGuest,
} from '../../../controllers/Firebase'

import {
  doGetRelatedArticles,
  doGetMarketingContent,
  doGetBestDeals,
  doGetWhatsOn,
  doGetFeaturedMarketingContent,
} from '../../../controllers/MarketingContent'

import { doContactUsSubmit } from '../../../controllers/ContactUs'

const mapStateToProps = reduxState => {
  const { dashboard, auth, profile, loyalty, errors, explore } = reduxState
  const { accessToken, firebaseMessagingToken } = auth
  const { primaryInfo, registrationToken } = profile
  const { selectedMallSlug } = explore

  const {
    heroBanner,
    heroBanners,
    featured,
    offers,
    promos,
    events,
    movies,
    merchants,
    malls,
    cmsMalls,
    showMarketingContentModal,
    marketingContentModalData,
    marketingContentModalStatus,
    showMerchantsListModal,
    merchantsListModalData,
    cardListModalData,
    showCardListModal,
    cardListModalStatus,
    showStoreModal,
    storeModalData,
    currentMallInModal,
    showOurMallModal,
    ourMallModalStatus,
    featureStatus,
    pasyalArticles,
  } = dashboard
  const { loyaltyPoints, transactionsEarned, transactionsRedeemed } = loyalty

  const { errorList } = errors

  return {
    heroBanner,
    heroBanners,
    featured,
    offers,
    promos,
    events,
    movies,
    merchants,
    malls,
    cmsMalls,
    primaryInfo,
    registrationToken,
    accessToken,
    showMarketingContentModal,
    marketingContentModalData,
    marketingContentModalStatus,
    showMerchantsListModal,
    merchantsListModalData,
    cardListModalData,
    showCardListModal,
    cardListModalStatus,
    showStoreModal,
    storeModalData,
    loyaltyPoints,
    transactionsEarned,
    transactionsRedeemed,
    currentMallInModal,
    showOurMallModal,
    ourMallModalStatus,
    errorList,
    selectedMallSlug,
    featureStatus,
    firebaseMessagingToken,
    pasyalArticles,
    doSubscribeToFirebaseGuest,
    doSubscribeToFirebaseMessaging,
    doGetRelatedArticles,
    doGetMarketingContent,
    doGetBestDeals,
    doGetWhatsOn,
    doGetFeaturedMarketingContent,
    doContactUsSubmit,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setLoyaltyPoints,
      setTransactionsEarned,
      setTransactionsRedeemed,
      setHeroBanner,
      setHeroBanners,
      setFeatured,
      setOffers,
      setPromos,
      setEvents,
      setMovies,
      setMerchants,
      setPrimaryInfo,
      setMalls,
      setCMSMalls,
      push,
      setAccessToken,
      setMarketingContentModalData,
      setMarketingContentModalStatus,
      setMerchantsListModalData,
      setStoreModalData,
      setCurrentMallInModal,
      setOurMallModalStatus,
      setCardListModalData,
      setCardListModalStatus,
      displayProfileModal,
      setTransportationMall,
      setProfileModalPage,
      setDisplayAppModal,
      waitRenderServer,
      renderServer,
      setError,
      removeError,
      setFeatureStatus,
      setFirebaseMessagingToken,
      setPasyalArticles,
    },
    dispatch,
  )

const ConnectedMainView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withFirebase(MainView))

export default ConnectedMainView
